module.exports = __webpack_public_path__ + "static/media/correct.42dd432f.m4a";